import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const ListUser = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 20V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V20"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <circle cx="12" cy="7" r="4" stroke="currentColor" />
  </svg>
);

export default ListUser;
